import { brandCodeMap } from '@/constants';
import { base } from '../base';

const chkTheme = {};

for (const item of Object.keys(brandCodeMap)) {
  chkTheme[item] = {
    checkbox: {
      primaryColor: base[item]?.chkColor.c0007,
    },
  };
}

export const checkbox = chkTheme;
